import Card from 'core/elements/card'
import React, { FC } from 'react'
import Text from 'core/elements/Text'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Tooltip from 'core/elements/tooltip'

const useStyles = makeStyles((theme: Theme) => ({
  cardComponent: {
    '& .card-body': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& .card-footer': {
      paddingBottom: 16,
    },
  },
  cardContent: {
    borderSpacing: '20px',
    position: 'relative',
    left: -20,
  },
  rowHelp: {
    width: 24,
  },
  rowHeader: {
    display: 'flex',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  rowValue: {
    marginLeft: theme.spacing(0.5),
    wordBreak: 'break-all',
    display: 'flex',
    gap: '4px',
    maxWidth: '400px',
  },
  cardHeader: {
    borderBottom: `solid 1px ${theme.palette.grey[200]}`,
  },
}))

export const DetailRow: FC<{
  label: string
  value: string | React.ReactNode
  info?: string | React.ReactNode
  lineClamp?: number
}> = ({ label, value, lineClamp, info }) => {
  const classes = useStyles()
  return (
    <tr data-testid="info-card-detail-row-container">
      <td data-testid="info-card-detail-row-label-cell">
        <Text
          className={classes.rowHeader}
          variant="body2"
          component="span"
          data-testid="info-card-detail-row-label-text"
        >
          {label} &nbsp;
          {info && (
            <Tooltip message={info}>
              <FontAwesomeIcon>info-circle</FontAwesomeIcon>
            </Tooltip>
          )}
        </Text>
      </td>
      <td data-testid="info-card-detail-row-value-cell">
        <Text
          className={classes.rowValue}
          variant="caption1"
          component={typeof value === 'string' ? 'span' : 'div'}
          lineClamp={lineClamp}
          data-testid="info-card-detail-row-value-content-text"
        >
          {value}
        </Text>
      </td>
    </tr>
  )
}

interface DetailRowProps {
  classes?: any
  items: any[]
}

// @ts-ignore
const DetailRowDiv = ({ items }: DetailRowProps) => {
  return Object.entries(items).map(([name, { value, info }]) => (
    <DetailRow
      key={name}
      label={name}
      value={value}
      info={info}
      data-testid={`detail-row-${name}`}
    />
  ))
}

// @ts-ignore
export const renderDetailRow = (items) => <DetailRowDiv items={items} />

const InfoCard = ({ items, title, footer = undefined, ...rest }) => {
  const classes = useStyles()
  return (
    <Card
      {...rest}
      title={title}
      footer={footer}
      className={classes.cardComponent}
      data-testid="info-card--component"
    >
      <table className={classes.cardContent} data-testid="info-card--content-table">
        <tbody data-testid="info-card--content-tbody">
          {Array.isArray(items) ? items.map(renderDetailRow) : renderDetailRow(items)}
        </tbody>
      </table>
    </Card>
  )
}

export default InfoCard
